import { NumberEasing, Tag, Text } from '../../../components'
import { toDollars } from '../../../utils/string'
import { ReactNodeProps } from '../../../types/reactNodeProps'
import { match, P } from 'ts-pattern'

interface Props extends ReactNodeProps {
  cost?: number
  invertColor?: boolean
}

export default function CostSheet(props: Props) {
  const dollarValue = toDollars(props.cost, {
    format: 'cents',
    signed: true,
    numeric: true,
  }) as number
  const sign = dollarValue > 0 ? '+' : dollarValue < 0 ? '-' : ''
  const { positiveColor, negativeColor } = props.invertColor
    ? { positiveColor: 'green', negativeColor: 'red' }
    : { positiveColor: 'red', negativeColor: 'green' }
  const color = match(dollarValue)
    .with(P.number.gt(0), () => positiveColor)
    .with(P.number.lt(0), () => negativeColor)
    .otherwise(() => 'grey')
  const dollarValueIsWholeNumber = dollarValue % 1 === 0

  return (
    <Tag className={props.className} color={`${color}-100`}>
      <Text
        className={match(color)
          .with('green', () => 'text-themed-green-900')
          .with('red', () => 'text-themed-red-500')
          .otherwise(() => 'text-themed-grey-500')}
        variant={'body1'}
      >
        {`${sign}$`}
        <NumberEasing
          decimals={dollarValue === 0 || dollarValueIsWholeNumber ? 0 : 2}
          value={Number(
            toDollars(props.cost, {
              format: 'cents',
              signed: false,
              numeric: true,
            }),
          )}
          speed={400}
          ease="quintOut"
        />
      </Text>
    </Tag>
  )
}
